import { render, staticRenderFns } from "./FreshChatTableMobile.vue?vue&type=template&id=38c51f6a&scoped=true"
import script from "./FreshChatTableMobile.vue?vue&type=script&lang=js"
export * from "./FreshChatTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c51f6a",
  null
  
)

export default component.exports